import { getItemReference } from "@tiicker/util/lib/contentful/helpers";
import { ContentfulLinkedReference } from "@tiicker/util/lib/contentful/types";
import Container from "components/core/Layout/Container/Container";
import Link from "next/link";
import React from "react";
import { triggerDownloadClickEvent } from "source/analytics-events";
import styles from "./BrandFiles.module.scss";
import FileCard from "./FileCard";

type Props = {
  files: {
    url: string;
    title: string;
    description: string;
    fileName: string;
  }[];
  tickerSymbol: string;
  downloadDescription?: string;
};

const BrandFiles = (props: Props) => {
  const click = (fileName: string) => {
    triggerDownloadClickEvent(props.tickerSymbol, fileName);
  };

  return (
    <Container>
      <div className={styles.container}>
        <div className={styles.headerSection}>
          <h3>Downloads</h3>
          {props.downloadDescription && (
            <p className={styles.downloadDesc}>{props.downloadDescription}</p>
          )}
        </div>
        <div className={styles.fileSection}>
          {props.files.map((file) => (
            <Link href={`https://${file.url}`}>
              <div className={styles.card} onClick={() => click(file.fileName)}>
                <FileCard
                  title={file.title}
                  description={file.description}
                  url={file.url}
                  tickerSymbol={props.tickerSymbol}
                />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </Container>
  );
};

export default BrandFiles;
